import React, { useState } from "react";
import Image from "next/image";
import classes from "./Accordion.module.scss";
import ArrowCircle from "../Icons/ArrowCircle";

interface AccordionItem {
  title: string;
  description: React.ReactNode;
}

interface AccordionProps {
  items: AccordionItem[];
  defaultOpenIndex?: number;
  theme?: "base" | "card";
  icon?: "plus" | "chevron" | "chevron-circle";
  titleStyles?: React.CSSProperties;
  contentStyles?:React.CSSProperties;
  accordionItemStyles?: React.CSSProperties;
}

const Accordion: React.FC<AccordionProps> = ({ items, defaultOpenIndex = 0, theme = "base", icon = "plus", titleStyles, contentStyles, accordionItemStyles }) => {
  const [activeIndex, setActiveIndex] = useState<number>(defaultOpenIndex);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  const themeClass = theme === "card" ? classes["accordion--card"] : classes["accordion--base"];

  const renderIcon = (isOpen: boolean) => {
    switch (icon) {
      case "plus":
        return <span className={classes["accordion-toggle"]}>{isOpen ? "−" : "+"}</span>;
      case "chevron":
        return (
          <span className={`${classes["accordion-icon"]} ${isOpen ? classes["accordion-icon--open"] : ""}`}>
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        );
      case "chevron-circle":
        return (
          <span className={`${classes["accordion-icon"]} ${isOpen ? classes["accordion-icon--open"] : ""}`}>
           <ArrowCircle />
          </span>
        );
    }
  };

  return (
    <div className={`${classes["accordion"]} ${themeClass}`}>
      {items.map((item, index) => {
        const isOpen = activeIndex === index;
        return (
          <div style={accordionItemStyles} className={`${classes["accordion-item"]} ${isOpen ? classes["accordion-item--active"] : ""}`} key={index}>
            <button className={classes["accordion-header"]} onClick={() => handleToggle(index)} aria-expanded={isOpen}>
              <span style={titleStyles} className={classes["accordion-title"]}>{item.title}</span>
              {renderIcon(isOpen)}
            </button>
            <div className={`${classes["accordion-body"]} ${isOpen ? classes["accordion-body--open"] : ""}`}>
              <div style={contentStyles} className={classes["accordion-content"]}>{item?.description ?? ""}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
